/**
 * TradingView Charting Library legend uses t("n/a") when the cursor is not on
 * a bar. Map that to "Ø" (same as Kuru / other TV embeds): a missing-value
 * glyph, not a $0 price, and not a backfilled candle. has_empty_bars stays
 * false; getBars still returns noData for empty pages.
 */
export const EMPTY_BAR_LEGEND = "Ø";

export const translateNaToZero = (key: string): string | null =>
  key === "n/a" ? EMPTY_BAR_LEGEND : null;
